import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bem } from '@argos/utils'

import { CoreCreators, ControlsCreators } from '../actions'
import { WaitingRoom, Form } from '../containers'

import Exit from './components/Exit/Exit'

const cn = bem({ prefix: 'lc-', block: 'forms' })

export class Forms extends React.Component {
  static propTypes = {
    activeControl: PropTypes.oneOf(['Messenger', 'ExitPrompt', 'Form', 'WaitingRoom']),
    activeControlPrevious: PropTypes.oneOf(['Messenger', 'ExitPrompt', 'Form', 'WaitingRoom']),
  }

  handleCancel = () => this.props.onCancel(this.props.lastActiveControl)

  render() {
    const { activeControl } = this.props

    return (
      <div className={cn()}>
        {activeControl === 'Form' && <Form />}

        {activeControl === 'WaitingRoom' && <WaitingRoom />}

        {activeControl === 'ExitPrompt' && <Exit onSubmit={this.props.onEndChat} onCancel={this.handleCancel} />}
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  activeControl: state.Controls.activeControl,
  lastActiveControl: state.Controls.lastActiveControl,
})

const mapDispatchToProps = (dispatch) => ({
  onEndChat: () => dispatch(CoreCreators.closeChat()),
  onCancel: (lastActiveControl) => dispatch(ControlsCreators.setActiveControl(lastActiveControl)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Forms)
